module.exports = __webpack_public_path__ + "static/media/laser.4642dfb3.svg";